import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';

import { selectedModule, selectedContentItem, selectedModuleId, selectedProgramId, selectedContentItems, selectedContent, getContentForModule, getFilteredComponents, getContentModules, getModulesPrograms } from '../redux/selectors';
import { xapiRequest } from '../redux/reducers/xapi';
import { selectUserContent, getUserProgramsFullRequest,selectAssessment, submitMCQ,selectAttempt, toggleAssignmentView, selectUserModule,
  selectUserPrograms, selectUserVersion, setFilter, selectItem, selectAssessmentContent } from '../redux/reducers/userProgramsFull';
import { toggleThinkToolPopup, toggleUserDashboard, toggleManagerPopup, setPopUps, toggleExtensionPopup, toggleResubmissionPopup, showSubmitModal, setReturnItem, showSaveModal } from '../redux/reducers/view';
import {
  saveTimeTaken,
  addComponentStatusRequest,
  saveStatus,
} from '../redux/reducers/addComponentStatus';
import Spinner from './Spinner';
import Modal from '@material-ui/core/Modal';
import {
  assignmentRequestRequest, assignmentSubmitRequest, resetFetch
} from '../redux/reducers/assignmentRequest';

import { CookiesProvider, Cookies } from 'react-cookie';

import { bake_cookie, read_cookie, delete_cookie } from 'sfcookies'

import ContentCard from './ContentCard';
import AssessmentCard from './AssessmentCard';
import IframePopup from './Popups/IframePopup';

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBSelect,
  MDBSelectInput,
  MDBSelectOptions,
  MDBSelectOption} from "mdbreact";

import { API_LINK, STATUSES } from '../constants';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';

import {
  learnerVersionsRequest,
  addPathToSaveVersion,
  resetLearnerVersion,
} from '../redux/reducers/savedVersions';

import { COLORS, commonStyles } from '../styles/styles';

import { convertTime, convertForWebinar } from '../utils';
import PDFTron from './PDFTron';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import LogbookCard from './Cards/LogbookCard';
import LogbookPopup from './Popups/LogbookPopup';
import WebinarCard from './Cards/WebinarCard';
import ZoomPopup from './Popups/ZoomPopup';
import { contentItemRequest } from '../redux/reducers/contentList';
import ExamCard from './Cards/ExamCard';
import { turnitinEulaRequest } from '../redux/reducers/turnitin';
var sha1 = require('sha1');
const cookies = new Cookies();
const API = `${API_LINK}api`;

const LearnerContentList = ({
  selectUserContent,
  selectedContentId,
  handleToggleUserDashboard,
  onModuleClick,
  handlePopupToggle,
  handleExtensionRequest,
  handleOpen,
  handleManager, 
  handleSubmit,
  handleResubRequest,
  handleSubmitExam,
  addComponentStatusRequest,
  loginReducer,
  content,
  contentReducer,
  handleView,
  changeFilter,
  handleBack,
  handleViewReport,
  filteredContent,
  handleOpenWebinar,
  popups,
  selectedModule
}) => {
    
  const renderContent = () =>
  filteredContent &&
  filteredContent
  .filter(item => {
    if ((item.type === 'Assignments' || item.type === 'WSR Assessments' || item.type === 'Assessment Builder')&& isNaN(new Date(item.due_date))) return false;
    return true;
  })
  .map((item, idx) => (
    <div
      className="col-lg-3 col-md-6 col-sm-6 mb-2"
      style={{ width: '100%', paddingLeft: 0, paddingRight: 0, paddingBottom: 5 }}
      key={item.contentId}
    >

      {(item.type == 'Assignments' || item.type === 'Assessment Builder' || item.type === 'Exam Builder') ? (
        <div>
         
          {(item.survey_exam === false &&
            item.survey_supplementary === false &&
            !isNaN(new Date(item.due_date))) ? (
            <AssessmentCard
              contentId={item.contentId}
              type={item.type}
              name={item.name}
              content={item}
              handleView={handleView}
              description={item.description}
              startDate={convertTime(item.startDate)}
              due_date={item.due_date}
              backgroundImg={item.backgroundImg}
              path={item.path}
              handleExtensionRequest={handleExtensionRequest}
              handleOpen={handleOpen}
              handleViewReport={handleViewReport}
              handleSubmit={handleSubmit}
              handleResubRequest={handleResubRequest}
              attempts={item.attempts}
              status={item.status}
              moduleName={item.moduleName}
              messageCount={item.messageCount}
              isSelected={item.contentId === selectedContentId}
              openMessages={handleToggleUserDashboard}
              selectedContentHandler={selectUserContent}
              isTransparent={false}
            />
          ) : (
            <div>

              <ExamCard
                contentId={item.contentId}
                type={item.type}
                name={item.name}
                content={item}
                handleView={handleView}
                description={item.description}
                startDate={item.start_date}
                due_date={item.due_date}
                handleViewReport={handleViewReport}
                backgroundImg={item.backgroundImg}
                path={item.path}
                handleExtensionRequest={handleExtensionRequest}
                handleOpen={handleOpen}
                handleSubmitExam={handleSubmitExam}
                handleResubRequest={handleResubRequest}
                attempts={item.attempts}
                status={item.status}
                endDate={item.end_date}
                moduleName={item.moduleName}
                messageCount={item.messageCount}
                isSelected={item.contentId === selectedContentId}
                openMessages={handleToggleUserDashboard}
                selectedContentHandler={selectUserContent}
                isTransparent={false}
                survey_exam={item}
              />
            </div>
          )}
        </div>
      ) : item.type === 'WSR Assessments' ? (
        <LogbookCard
          contentId={item.contentId}
          type={item.type}
          name={item.name}
          item={item}
          content={item}
          handleView={handleView}
          description={item.description}
          startDate={convertTime(item.startDate)}
          due_date={item.due_date}
          backgroundImg={item.backgroundImg}
          path={item.path}
          handleExtensionRequest={handleExtensionRequest}
          handleOpen={handleOpen}
          handleManager={handleManager}
          handleResubRequest={handleResubRequest}
          attempts={item.attempts}
          status={item.status}
          moduleName={item.moduleName}
          messageCount={item.messageCount}
          isSelected={item.contentId === selectedContentId}
          openMessages={handleToggleUserDashboard}
          selectedContentHandler={selectUserContent}
          isTransparent={false}
          allowIconClick={true}
        />
      ) : item.type === 'Webinar' ? (
        <WebinarCard
          contentId={item.contentId}
          type={item.type}
          name={item.name}
          content={item}
          item={item}
          handleView={handleView}
          description={item.description}
          start_date={convertTime(item.due_date)}
          meetingId={item.meeting_id}
          password={item.password}
          due_date={new Date(item.due_date)}
          backgroundImg={item.backgroundImg}
          path={item.path}
          handleExtensionRequest={handleExtensionRequest}
          handleOpen={handleOpenWebinar}
          handleManager={handleManager}
          handleResubRequest={handleResubRequest}
          attempts={item.attempts}
          status={item.status}
          moduleName={item.moduleName}
          messageCount={item.messageCount}
          isSelected={item.contentId === selectedContentId}
          openMessages={handleToggleUserDashboard}
          selectedContentHandler={selectUserContent}
          isTransparent={false}
          allowIconClick={true}
        />
      ) : (
        <ContentCard
          contentId={item.contentId}
          type={item.type}
          name={item.name}
          item={item}
          description={item.description}
          startDate={convertTime(item.startDate)}
          dueDate={convertTime(item.due_date)}
          backgroundImg={item.backgroundImg}
          path={item.path}
          status={item.status}
          collab={item.pdf_collab ? item.pdf_collab : 0}
          messageCount={item.messageCount}
          isSelected={item.contentId === selectedContentId}
          openMessages={handleToggleUserDashboard}
          selectedContentHandler={selectUserContent}
          isTransparent={false}
          onModuleClick={onModuleClick}
        />
      )}
    </div>
  ));
 

  return (
    <MDBCard  className="z-depth-2 rounded-0 yellow-card" >
      <MDBBtn
        floating
        tag='a'
        size='sm'
        className='ml-auto ml-4  d-md-none navBack'
        action
        onClick={()=>handleBack()}
      >
      <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
    </MDBBtn>
    <div className='gothamBlack text-dark text-left pt-3 pl-3'>
          CONTENT
    </div>
    
    <div style={{height:40, backgroundColor:'#EBEBEB', marginTop:15}}>

  <Fragment>
  <MDBSelect  className="filterHolder" label=""  getValue={changeFilter} style={{paddingLeft:16}}>
          <MDBSelectInput selected="Filter by Type" />
          <MDBSelectOptions>
            <MDBSelectOption disabled>Filter by Type</MDBSelectOption>
            <MDBSelectOption value="All">All</MDBSelectOption>
            <MDBSelectOption value="Journal">Activity</MDBSelectOption>
            <MDBSelectOption value="ThinkTool">ThinkTool</MDBSelectOption>
            <MDBSelectOption value="Assignments">Assessment</MDBSelectOption>
            <MDBSelectOption value="Survey">Survey</MDBSelectOption>
            <MDBSelectOption value="Video">Video</MDBSelectOption>
            <MDBSelectOption value="HTML Articlulate">HTML</MDBSelectOption>
            <MDBSelectOption value="Document">Document</MDBSelectOption>
          </MDBSelectOptions>
        </MDBSelect>
      
    </Fragment>
  </div>

  <div className="contentScrollComp">
   
  <MDBRow style={{width:'100%', margin: '0 auto'}}>{renderContent()}</MDBRow>
  <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{((contentReducer.fetching==true)) && <div onClick={(e)=>e.stopPropagation() } style={{pointerEvents:'all',backgroundColor:'#FFFFFF', position:'absolute', top:88, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
         color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>

   
</div>
{}
 

       

      <LogbookPopup  handleSubmitLog = {handleSubmit}/>
</MDBCard>
     
   
  );
};

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  selectedProgramId: selectedProgramId(state),
  selectedModuleId:selectedModuleId(state),
  selectedModule: selectedModule(state),
  filteredContent: getFilteredComponents(state),
  selectedContentItem: selectedContent(state),
  statusUpdate: state.addComponentStatus,
  windowDeleteIndex: state.viewReducer.windowDeleteIndex,
  popups: state.viewReducer.popups,
  contentReducer: state.contentListReducer,
  content: getContentModules(state),
  view:state.viewReducer
});

const mapDispatchToProps = dispatch => ({
  setFilter: contentId => dispatch(setFilter(contentId)),
  selectUserContent: contentId => dispatch(selectUserContent(contentId)),
  selectUserModule: moduleId => dispatch(selectUserModule(moduleId)),
  selectUserPrograms: moduleId => dispatch(selectUserPrograms(moduleId)),
  selectAssessment: surveyId => dispatch(selectAssessment(surveyId)),
  submitMCQ: value => dispatch(submitMCQ(value)),
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  toggleManagerPopup: value => dispatch(toggleManagerPopup(value)),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  getContentItem: () => dispatch(contentItemRequest()),
  saveTimeTaken: time => dispatch(saveTimeTaken(time)),
  addComponentStatusRequest: () => dispatch(addComponentStatusRequest()),
  saveStatus: status => dispatch(saveStatus(status)),
  selectAttempt: moduleId => dispatch(selectAttempt(moduleId)),
  toggleAssignmentView: type => dispatch(toggleAssignmentView(type)),
  assignmentRequestRequest: type => dispatch(assignmentRequestRequest(type)),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  setPopups: array => dispatch(setPopUps(array)),
  selectAssessmentContent: obj => dispatch(selectAssessmentContent(obj)),
  toggleExtensionPopup: bool => dispatch(toggleExtensionPopup(bool)),
  resetFetch: () => dispatch(resetFetch()),
  toggleResubmissionPopup: bool => dispatch(toggleResubmissionPopup(bool)),
  assignmentSubmitRequest: obj => dispatch(assignmentSubmitRequest(obj)),
  showSubmitModal: obj => dispatch(showSubmitModal(obj)),
  turnitinEulaRequest:()=> dispatch(turnitinEulaRequest()),
  setReturnItem: (item) => dispatch(setReturnItem(item)),
  selectItem: (item) => dispatch(selectItem(item)),
  showSaveModal:bool => dispatch(showSaveModal(bool)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isShowPopup', 'togglePopup', false),
  withState('isShowDocument', 'togglePopupDocument', false),
  withState('notStartedNumber', 'notStartedCounter', 0),
  withState('filterVal', 'switchFilter', null),
  lifecycle({
    componentWillMount(){
      this.props.setFilter(['All'])

    },
      componentWillReceiveProps(nextProps){
        
        if(this.props.statusUpdate.isFetched==false && nextProps.statusUpdate.isFetched==true){
          //this.props.getContentItem()
        }
     
      
      }
  }
  ),
  withHandlers({
    changeFilter: props => item => {
     //props.getUserProgramsFullRequest()
     props.setFilter(['item'])
      props.setFilter(item)
    },
    handleBack: props => () => {
      props.history.push(`/modules/${props.selectedProgramId}`);
    },
    handleThinkToolClick: props => item => {
      const {
        history,
        selectedProgramId, 
        selectedModuleId,
        selectedModule,
        selectUserContent,
        selectUserModule,
        toggleThinkToolPopup,
        selectUserVersion,
        xapiRequest,
        content,
        selectItem, showSaveModal
      } = props;
      const isPopup = content.find(contentItem => contentItem.contentId === item.contentId).savedVersionsPresent;
      props.selectItem(item)
      selectUserContent(item.contentId);
      selectUserModule(item.module_id)
      if(item.status=='not started'){
        xapiRequest({ xapiType: `Started`});
      }
      if(item.status=='in progress'){
        xapiRequest({ xapiType: `Opened`});
      }
      if(item.status=='completed'){
        xapiRequest({ xapiType: `Opened`});
      }

      selectItem(item)
      if (isPopup && item.type!='Journal') {
        
        toggleThinkToolPopup(true);
      } else {
        
        if(isPopup){
          selectUserVersion(null)
          history.push(`/tools/${selectedProgramId}/${item.contentId}`);
        }else{
          selectUserVersion(null)
          history.push(`/tools/${selectedProgramId}/${item.contentId}`);
        }
        
      }
      bake_cookie('returnItem', JSON.stringify(item ));
    },
    handlePopupToggle: props => (item, closed, zDepth) => {
      const { isShowPopup, xapiRequest, getUserProgramsFullRequest, selectedContent } = props;
     
      props.selectItem(item)
     
     
      //xapiRequest({ xapiType: `${xapiType}`});
      if (isShowPopup) {
        //props.getContentItem();
      }
      if(closed==true){
        var itemToRemove
      
        var tmp = props.popups;
        tmp.splice(props.windowDeleteIndex,1)
        props.setPopups(tmp);
        props.togglePopup(!isShowPopup);
      }else{
        var tmp = props.popups;
        tmp.push(item);
        props.setPopups(tmp);
        props.togglePopup(!isShowPopup);

        bake_cookie('returnItem', JSON.stringify(item ));
      }
      
    },
    handlePopupToggleDocument: props => item => {
      const { isShowDocument, xapiRequest, getUserProgramsFullRequest } = props;

      props.selectItem(item)

      if (isShowDocument) {
        //props.getContentItem();
      }

      bake_cookie('returnItem', JSON.stringify(item ));
      props.togglePopupDocument(!isShowDocument);
    },
    
    handleToggleUserDashboard: props => value => {
      // if (!props.view.isUserDashboardOpened) {
      //   props.toggleUserDashboard(value);
      // }
    },
    
   
  }),
  withHandlers({
    onModuleClick: props => item => {
      const { handlePopupToggle, handleThinkToolClick, selectUserContent, handlePopupToggleDocument } = props;
      selectUserContent(item.contentId);
      props.selectItem(item)
      if(item.type=='Document'){
        var tmp = item.path.split('pdf');
        if(tmp.length>1){
          handlePopupToggle(item);
        }else{
          props.showSaveModal(true)
          window.open(item.path, '_blank');
        }
      }else if (item.type !== 'ThinkTool' && item.type !== 'Journal') {
        props.selectItem(item);
        if(item.type=='Survey' && item.status!='completed'){
          handlePopupToggle(item);
        }else if(item.type!='Survey'){
          handlePopupToggle(item);
        }
       
      } else {
        
        handleThinkToolClick(item);
      }
      bake_cookie('returnItem', JSON.stringify(item ));
    },
    handleExtensionRequest: props => item => {
      const {
        selectAssessmentContent,
        assignmentRequestRequest,
        saveStatus,
        selectUserContent,
        addComponentStatusRequest, 
        toggleExtensionPopup
      } = props;

        // selectUserContent(item.contentId)
        // selectAssessment(item.survey_id);
        // // selectUserAssessment(content.survey_id);
        // assignmentRequestRequest('extension');
        selectAssessmentContent(item)
        props.resetFetch()
        toggleExtensionPopup(true)
        // saveStatus(STATUSES.extension_request.value);
        // addComponentStatusRequest();
     
      
    },
    handleView: props => (content, item) => {
      const {
        
        selectAssessment,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        assignmentRequestRequest,
        toggleAssignmentView,
        toggleAssignmentSubmit,
        submitMCQ,
        selectAssessmentContent,
        selectAttempt,
        handlePopupToggle
      } = props;
      props.selectItem(item)

      toggleAssignmentView(true);
      selectAssessment(content.survey_id);
      selectAttempt(item.attempt);

      if(content.program_id){
        
        selectUserPrograms(content.program_id);
        selectUserModule(content.module_id);
      }
      selectUserContent(content.contentId);

      selectAssessmentContent(content);
      selectAssessment(content.survey_id);
      submitMCQ(false);
      handlePopupToggle(content);

      // selectUserAssessment(content.survey_id);
      // assignmentRequestRequest('retake');
      // saveStatus(STATUSES.resubmission_request.value);
      // addComponentStatusRequest();
    },
    handleResubRequest: props => item => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        saveStatus,
        addComponentStatusRequest
      } = props;
        selectUserContent(item.contentId)
        selectAssessment(item.survey_id);
        // selectUserAssessment(content.survey_id);
        assignmentRequestRequest('retake');
        toggleResubmissionPopup(true)
        // saveStatus(STATUSES.extension_request.value);
        // addComponentStatusRequest();
     
      
    },
    
    handleFirstFail: props => e => {
      const {
        selectUserAssessment,
        assignmentRequestRequest,
        addComponentStatusRequest,
        saveStatus,
      } = props;
      
      selectUserAssessment(e.survey_id);
      assignmentRequestRequest('retake');
      // saveStatus(STATUSES.resubmission_request.value);
      // addComponentStatusRequest();

    },
    handleOpen: props => content => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        selectAssessmentContent,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent, 
        toggleAssignmentView,
        selectItem
      } = props;
      props.selectItem(content)
      if(content.program_id){
        
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
      toggleAssignmentView(false);
      selectUserPrograms(content.program_id);
      selectUserModule(content.module_id);
      selectUserContent(content.contentId);
      selectAssessment(content.survey_id);
      selectAssessmentContent(content)
      submitMCQ(false);

      // var tmp = props.popups;
      // tmp.push(content);
      // props.setPopups(tmp);
      handlePopupToggle(content);
    },
    handleViewReport: props => async(content) => {
      const data = JSON.stringify({
        "viewer_user_id": props.loginReducer.user.userId,
        "locale": "en-GB",
        "viewer_default_permission_set": "LEARNER",
        "author_metadata_override": {
          "family_name": props.loginReducer.user.lastName,
          "given_name": props.loginReducer.user.firstName
        }
      });
      var result =  await axios({
        method: 'get',
        url: `${API}/tii_get_results`,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${props.loginReducer.token}`,
        },
        params: {
          tii_data: data,
          statement_id: content.tii_id
        },
      })
      window.open(result.data.viewer_url)
    },
    handleOpenWebinar: props => content => {

      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent, 
        toggleAssignmentView,
        loginReducer,
      } = props;
      
      if(content.program_id){
        
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
        toggleAssignmentView(false);
        selectUserPrograms(content.program_id);
        selectUserModule(content.module_id);
        selectUserContent(content.contentId);
        selectAssessment(content.survey_id);
        submitMCQ(false);
        
        // var tmp = props.popups;
        // tmp.push(content);
        // props.setPopups(tmp);
       // handlePopupToggle(content);
       try {
        var checksum = sha1('joinfullName='+escape(loginReducer.user.firstName+' '+loginReducer.user.lastName)+'&meetingID='+content.meeting_id+'&password='+content.password+'&redirect=truey0wiq50aUjh5Un9cFR0ewUl9Xog9uPXrJMQJCK80Pw')
      } catch (error) {
        
      }
       window.open('https://bbb.cpslearn.co.za/bigbluebutton/api/join?fullName='+escape(loginReducer.user.firstName+' '+loginReducer.user.lastName)+'&meetingID='+content.meeting_id+'&password='+content.password+'&redirect=true&checksum='+checksum)
     
    },
    handleManager: props => content => {

      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        toggleManagerPopup,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent
      } = props;
      
      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }
      props.selectItem(selectedContent)
        submitMCQ(true);
        selectUserPrograms(content.program_id);
        selectUserModule(content.module_id);
        selectUserContent(content.contentId);
        selectAssessment(content.survey_id);

        toggleManagerPopup(content);
    },
    handleSubmitExam: props => content => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        handleAssessmentPopupToggle,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        selectAssessmentContent,
        assignmentSubmitRequest
      } = props;

      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }

      //if(content.survey_exam==false){
      submitMCQ(true);
      selectAssessmentContent(content)
      selectUserContent(content.contentId);
      selectAssessment(content.survey_id);
      // }
      // props.selectContent(content)
      props.showSubmitModal(true)
      // assignmentSubmitRequest(content)
      // handlePopupToggle(content);
    },
    handleSubmit: props => content => {
      const {
        selectAssessment,
        assignmentRequestRequest,
        handlePopupToggle,
        toggleManagerPopup,
        submitMCQ,
        selectUserPrograms,
        selectUserModule,
        selectUserContent,
        selectAssessmentContent
      } = props;

      if(content.program_id){
        // selectUserPrograms(content.program_id);
        // selectUserModule(content.module_id);
      }

      submitMCQ(true);
      props.setPopups([]);
      selectUserContent(content.contentId);
      selectAssessment(content.survey_id);
      selectAssessmentContent(content)
      handlePopupToggle(content);
    },
  }),
  withStyles(styles),
)(LearnerContentList);


LearnerContentList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  selectUserContent: PropTypes.instanceOf(Object),
  selectedModule: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  selectedContentId: PropTypes.number,
  handleToggleUserDashboard: PropTypes.func,
  handlePopupToggle: PropTypes.func,
  isShowPopup: PropTypes.bool,
  selectedContentItem: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.bool]),
  onModuleClick: PropTypes.func,
  handlePauseVideo: PropTypes.func,
  saveStatus: PropTypes.func,
  addComponentStatusRequest: PropTypes.func,
  addComponentStatus: PropTypes.instanceOf(Object)
};
